export const getEnrollSteps = (includePay = false) => {
  const firstSteps = [
    {
      name: 'You',
    },
    {
      name: 'Documents',
    },
    {
      name: 'Contact',
    },
    {
      name: 'Eligibility',
    },
    {
      name: 'Location',
    },
  ]

  const payStep = [
    {
      name: 'Pay',
    },
  ]

  const lastSteps = [
    {
      name: 'Complete',
    },
  ]
  return includePay
    ? [...firstSteps, ...payStep, ...lastSteps]
    : [...firstSteps, ...lastSteps]
}

export const renewalSteps = [
  {
    name: 'Eligibility',
  },
  {
    name: 'Contact',
  },
  {
    name: 'Pay',
  },
  {
    name: 'Complete',
  },
]
